<template>
  <div>
    <ExpandableSettingsItem :title="$t('message.DISPLAY')">
      <div>
        <IntCheckbox
          :value="currentTeam.dbDisplayInfos"
          :title="$t('message.SETTINGS_DISPLAY_CURRENT_INFOS')"
          @input="save('dbDisplayInfos', $event)"
        />
      </div>
    </ExpandableSettingsItem>
    <ExpandableSettingsItem :title="$t('message.CRITICAL_PROBLEMS')">
      <div>
        <div class="legend">{{ $t('message.LOWEST_POSSIBLE_IMPACT') }}</div>
        <input
          ref="minImpact"
          :value="currentTeam.dbProblemsMinImpact"
          class="generic-border--thin-border generic-border--focus-shadow mt5em"
          type="number"
          pattern="[0-9]+([\.,][0-9]+)?"
          min="0"
          max="3"
          step="0.1"
          @input="save('dbProblemsMinImpact', $refs.minImpact.value)"
        >
        <div class="legend mt10em">{{ $t('message.ELAPSED_DAYS_SINCE_REPORT') }}</div>
        <input
          ref="elapsedDays"
          :value="currentTeam.dbProblemsElapsedDays"
          class="generic-border--thin-border generic-border--focus-shadow mt5em"
          type="number"
          min="0"
          @input="save('dbProblemsElapsedDays', $refs.elapsedDays.value)"
        >
      </div>
    </ExpandableSettingsItem>
    <ExpandableSettingsItem :title="$t('message.ACTIONS')">
      <div>
        <div class="legend">{{ $t("message.N_DB_ACTIONS_LINES") }}</div>
        <input
          ref="actionLines"
          :value="currentTeam.dbActionLines"
          class="generic-border--thin-border generic-border--focus-shadow mt5em"
          type="number"
          pattern="[0-9]+"
          min="1"
          step="1"
          @input="save('dbActionLines', $refs.actionLines.value)"
        >
      </div>
    </ExpandableSettingsItem>
  </div>
</template>

<script>
import toastr from 'toastr';
// Vuex utils
import { SET_TEAM_PARAM } from '@/store/action-types';
import { SET_CURRENT_TEAM_PARAM } from '@/store/mutation-types';
// Components
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import IntCheckbox from '@/components/int-checkbox.vue';
import RadioGroup from '@/components/radio-group.vue';

export default {

  name: 'SettingsDashboard',

  components: {
    ExpandableSettingsItem,
    IntCheckbox,
    RadioGroup,
  },

  data() {
    return {
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.SETTINGS_DASHBOARD'),
    };
  },

  created() {
    this.$http.get('/server/team/parameters').then((response) => {
      this.$store.commit(SET_CURRENT_TEAM_PARAM, { payload: response.data, response });
    });
  },

  methods: {
    save(param, value) {
      if (param === 'dbProblemsMinImpact') {
        value = Number(value).sBetweenBoundaries(0, 3);
      }
      if (param === 'dbProblemsElapsedDays' || param === 'dbActionLines') {
        value = Number(value);
      }
      this.$store.dispatch(SET_TEAM_PARAM, { [param]: value });
    },
  },
};
</script>
